import Rules from "../rules.js";
import Utils from "../utils.js";

class PresRequirements {
  constructor() {}
  setup() {
    window.Requirements = (group, country, higherEducation, lang) => (
      `
      ${Header(i18n.titleRequirements)}
      ${AcademicBackground(country, higherEducation, lang)}
      ${LanguageRequirements(lang)}
      ${FinancialRequirements(group, lang)}
      ${PoliceRequirements(lang)}
      `
    )
    
    function AcademicBackground(country, higherEducation, lang) {
      // General
      var html = "";
      var text = Fellestekst("opptak-master-generelle-krav", "master-opptakskrav-bachelor", lang);
      if(text) html += text;
    
      // Land-specific
      for(var i = 0; i < higherEducation.length; i++) {
        text = Fellestekst("opptak-master-utdanningskrav-land", higherEducation[i] + "-utdanningskrav", lang); // Heading from fellestekst
        if(/###COUNTRY###$/.test($.trim($($.parseHTML(text)).text()))) {
          text = "";
        } else {
          text = text.replace(/###COUNTRY###/igm, App.countries[higherEducation[i]])
        }
        if(text) html += text;
      }
    
      // Specialization
      if(!App.program.experienceBased) {
        text = Fellestekst("opptak-master-generelle-krav", "master-opptakskrav-spesialisering", lang);
        if(text) html += text;
      }
    
      // Optional text
      text = App.program["opptak-master-spesielle-krav-fri"];
      if(text) html += HeaderDowngrade(text);
    
       // Innpassing tidligere utdanning
      if($.inArray("no", higherEducation) != -1) {
        text = Fellestekst("opptak-master-tidligere-utdanning", "opptak-master-tidligere-utdanning-uio", lang);
        if(text) html += text;
      }
    
      if(html != "") html = AccordionHeader(i18n.academicRequirements) + html;
      return html;
    }
    
    function LanguageRequirements(lang) {
      var html = "";
    
      var textId = App.program.fellestekst["opptak-master-sprakkrav"];
      var text = Fellestekst("opptak-master-sprakkrav", textId, lang);
      if(text) {
        // Include other fellestekst's by ID in the fellestekst
        var idRegEx = /#{3}ID:([^#]+)#{3}/i;
        var includedTextId = text.match(idRegEx);
        if(includedTextId != null && includedTextId.length === 2 && textId != includedTextId[1]) {
          text = text.replace(idRegEx, "");
          html += text;
    
          text = Fellestekst("opptak-master-sprakkrav", includedTextId[1], lang);
          if(text) {
            html += text;
          }
        } else {
          if(text) html += text;
        }
      }
      text = HeaderDowngrade(App.program["opptak-master-sprakkrav-fri"]);
      if(text) html += text;
      if(html != "") html = AccordionHeader(i18n.languageRequirements) + html;
      return html;
    }
    
    function PoliceRequirements(lang) {
      var html = "";
      var text = Fellestekst("opptak-master-politiattest", App.program.fellestekst["opptak-master-politiattest"], lang);
      if(text) html += AccordionHeader(i18n.policeRequirements) + text;
      return html;
    }
    
    function FinancialRequirements(group, lang) {
      var html = "";
      if(Rules.showFinancing(group)) {
        if(Rules.showFinancingExtraEMHEM(group)) {
          var text = Fellestekst("opptak-master-finansiering", "master-opptak-finansiering-emhem-SFMASTER", lang);
          if(text) html += text;
        } else if(App.program.programCode === "IBSENONLINE") {
          var text = Fellestekst("opptak-master-finansiering", "master-opptak-finansiering-ibsenonline-SFMASTER", lang);
          if(text) html += text;
        } else {
          var text = Fellestekst("opptak-master-finansiering", "master-opptak-finansiering", lang);
          if(text) html += text;
        }
      }
      if(Rules.showFinancingExtraEMHEM(group)) {
        var text = Fellestekst("opptak-master-finansiering", "master-opptak-finansiering-emhem", lang);
        if(text) html += text;
      }
      if(html != "") html = AccordionHeader(i18n.financingRequirements) + html;
      return html;
    }    
  }
}
export default new PresRequirements;